module.exports = "<p>\n  home-page works!\n</p>\n"